<template>
  <b-modal
    id="contact"
    centered
    hide-footer
    hide-header
    size="lg"
    @show="onShow"
    @hide="onHide"
  >
    <ProcessingGif />
    <template v-if="!isLoading">
      <b-row v-if="!!criticalError" class="alert-messages">
        <div class="alert-container" v-bind:class="{'mt-0': !session}">
          <span v-if="errorMessage">{{errorMessage}}</span>
          <span v-else>Oops, Something went wrong. <img :src="require('@/assets/images/sad.svg')" class="sad-icon" alt=""></span>
        </div>
      </b-row>
      <ContactSupportForm v-if="session" :lifeline-type="lifelineType" @email="sendMessage"></ContactSupportForm>
    </template>
    <b-link block class="centered-block close-button" variant="secondary" @click="close()">&times;</b-link>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
import { LifelineType, SessionResult } from '@/constants'
import { getErrorData } from '@/utils'
const ContactSupportForm = () => import('./ContactSupportForm')
const ProcessingGif = () => import('./ProcessingGif')

export default {
  name: 'Lifeline',
  components: {ProcessingGif, ContactSupportForm},
  data: function() {
    return {
      lifelineType: null,
      notifying: false,
      lifelineActionTaken: false
    }
  },
  computed: {
    ...mapState(['session', 'campaign', 'criticalError', 'isLoading']),
    errorMessage: function() {
      if (this.criticalError && this.criticalError.response && this.criticalError.response.data) {
        const err = getErrorData(this.criticalError)
        if (err.data && 'error_message' in err.data) {
          return err.data.error_message
        }
      }

      return null
    }
  },
  methods: {
    close: function() {
      this.$bvModal.hide('contact')
    },
    complete: function(msg = null) {
      setTimeout(() => {
        if (this.notifying) {
          this.$store.commit('busy')
          this.complete(msg) // we're busy notifying, so wait a little then check again
        } else {
          this.$store.commit('reset_lifeline')
          this.$store.commit('reset_idle_timer')
          this.$store.commit('ready')
          this.close()
          this.$router.replace({name: 'logout', query: {msg: msg}})
        }
      }, 500)
    },
    sendMessage: function(contactForm) {
      this.notifying = false
      this.$store.commit('busy')
      this.$store.dispatch('email', contactForm)
        .then(session => {
          this.complete('Your message has been successfully sent to us.<br/>We will get back to you soon.')
        })
        .catch(err => {
          // sending email failed, so notify server of failed status and show the phone number
          console.log(err)
          this.lifelineType = LifelineType.Phone
          this.$store.commit('lifeline_error', err)

          this.notifying = true
          const msg = err.error ? err.error.message : err.message
          this.$store.dispatch('update_session', {result: SessionResult.LifelineContactFailed, message: msg || null})
            .finally(() => {
              this.notifying = false
            })
        })
    },
    onHide: function(event) {
      this.lifelineType = null

      if (this.session && this.session.can_exit_lifeline) {
        this.$store.commit('reset_lifeline')
        this.$store.commit('clear_messages')
        this.$store.commit('reset_idle_timer')
        this.$store.commit('busy')
        this.$store.dispatch('close')
          .then(session => {
            console.log('Closed the lifeline')
            this.$router.go(0) // refresh
          })
          .catch(err => {
            console.log(err)

            if (err.response && err.response.status === 422) {
              // unprocessable, but not an error - just refresh
              this.$store.dispatch('get_session')
                .then(session => {
                  this.$router.go(0)
                })
                .catch(err => {
                  this.$store.commit('critical_error', err)
                })
            } else {
              this.$store.commit('critical_error', err)
            }
          })
      } else if (!this.isLoading) {
        this.complete() // reset the session if lifeline action taken or critical error
      }
    },
    onShow: function(event) {
      let lifelineType = LifelineType.Email // default value

      if (this.session && this.session.lifeline_type) {
        lifelineType = this.session.lifeline_type
      }

      if (lifelineType === LifelineType.Email) {
        if (this.campaign && this.campaign.support_email_fields && this.campaign.support_email_fields.length) {
          lifelineType = LifelineType.Email
        } else {
          // if call center closed, but nothing else is available, show the phone number
          lifelineType = LifelineType.Phone
        }
      }
      if (lifelineType === LifelineType.Phone && !(this.session && this.session.phone_contact_url)) {
        lifelineType = LifelineType.Email
      }

      this.lifelineType = lifelineType
    }
  }
}
</script>

<style scoped>

</style>
